module.exports = __webpack_public_path__ + "img/3-6.20329d5.jpg";